import { PaccJobCurationResultVO, PaccJobCurationVO } from '@domain/vo/phs/pacc/competence/PaccJobCurationResultVO';
import { jobCurationResultColorMap, jobCurationResultTextMap } from '@domain/constant/jobCurationResultType';
import classnames from 'classnames/bind';
import styles from './jobBarChart.module.scss';

const cx = classnames.bind(styles);

const MAX_BAR_WIDTH = 558;

interface BarProps {
  title: string;
  badge: string;
  value: number;
  color: string;
  isEmphasis?: boolean;
  onClick?: () => void;
}

const Bar = ({ title, badge, value, color, isEmphasis, onClick }: BarProps) => {
  return (
    <div className={cx('bar', { emphasis: isEmphasis }, color)} onClick={onClick}>
      <em className={cx('badge')}>{badge}</em>
      <strong className={cx('title')}>{title}</strong>
      <span className={cx('value')} style={{ width: value }} />
    </div>
  );
};

interface JobBarChartProps {
  paccJobCurationResult: PaccJobCurationResultVO;
  selectedJobCuration: PaccJobCurationVO | null;
  setSelectedJobCuration: (jobCurations: PaccJobCurationVO | null) => void;
}

const JobBarChart = ({ paccJobCurationResult, selectedJobCuration, setSelectedJobCuration }: JobBarChartProps) => {
  const barEls = paccJobCurationResult.jobCurations?.map((jobCuration, i) => {
    const { resultType, jobTitleName, score } = jobCuration;

    return (
      <Bar
        key={i}
        title={jobTitleName}
        badge={jobCurationResultTextMap[resultType]}
        value={(MAX_BAR_WIDTH * score) / 100}
        color={jobCurationResultColorMap[resultType]}
        isEmphasis={selectedJobCuration === jobCuration}
        onClick={() => setSelectedJobCuration(jobCuration)}
      />
    );
  });

  return (
    <div className={cx('chartArea')}>
      <span className={cx('desc')}>직무명을 클릭하여 내 역량과 직무를 비교 분석한 정보를 확인해보세요.</span>
      <div className={cx('chartWrap')}>{barEls}</div>
    </div>
  );
};

export default JobBarChart;
